import axios from 'axios';
import { GOOGLE_API_KEY } from '@app/common/utils/constants';

export default {
    getPlace (lat, lng) {
        return axios
            .get(
                `https://maps.googleapis.com/maps/api/geocode/json?language=en&latlng=${lat},${lng}&key=${GOOGLE_API_KEY}`
            )
            .then((response) => {
                if (response && response.data && response.data.results) {
                    return response.data.results[0];
                }
            });
    },
    reverseGeoCode (place) {
        const addressComponents = place.address_components;
        const postalCodeComponent = addressComponents.find(
            (item) => item.types.indexOf('postal_code') > -1
        );
        const countryComponent = addressComponents.find(
            (item) => item.types.indexOf('country') > -1
        );
        const stateComponent = addressComponents.find(
            // state component is the level of 1 and city is level 2
            (item) => item.types.indexOf('administrative_area_level_1') > -1
        );
        const cityComponent = addressComponents.find(
            (item) => item.types.indexOf('administrative_area_level_2') > -1
        );
        const districtComponent = addressComponents.find(
            (item) => item.types.indexOf('administrative_area_level_2') > -1
        );
        const addressComponent = addressComponents.find(
            (item) => item.types.indexOf('administrative_area_level_4') > -1
        );
        const streetNumber = addressComponents.find(
            (item) => item.types.indexOf('street_number') > -1
        );
        const route = addressComponents.find((item) => item.types.indexOf('route') > -1);
        const locality = addressComponents.find((item) => item.types.indexOf('locality') > -1);

        const japanAddress1 = addressComponents.find(
            (item) => item.types.indexOf('sublocality_level_3') > -1
        );
        const japanAddress2 = addressComponents.find(
            (item) => item.types.indexOf('sublocality_level_4') > -1
        );
        const japanAddress3 = addressComponents.find(
            (item) => item.types.indexOf('premise') > -1
        );
        const japanAddress4 = addressComponents.find(
            (item) => item.types.indexOf('sublocality_level_2') > -1
        );

        const latestGeocodedAddress = {
            street1: null,
            street2: null,
            country: null,
            city: null,
            state: null,
            district: null,
            postal_code: null,
            address_text: place.formatted_address,
        };

        if (postalCodeComponent) {
            latestGeocodedAddress.postal_code = postalCodeComponent.long_name;
        }
        if (countryComponent) {
            latestGeocodedAddress.country = countryComponent.long_name;
        }
        if (stateComponent) {
            latestGeocodedAddress.state = stateComponent.short_name;
        }
        if (cityComponent) {
            latestGeocodedAddress.city = cityComponent.long_name;
        }
        if (districtComponent) {
            latestGeocodedAddress.district = districtComponent.long_name;
        }

        if ((streetNumber || route || addressComponent) && !japanAddress1) {
            latestGeocodedAddress.street1 = streetNumber ? streetNumber.long_name : null;

            if (route) {
                latestGeocodedAddress.street1 = latestGeocodedAddress.street1
                    ? `${latestGeocodedAddress.street1} ${route.long_name}`
                    : route.long_name;
            }
            if (addressComponent) {
                latestGeocodedAddress.street1 = latestGeocodedAddress.street1
                    ? `${latestGeocodedAddress.street1} ${addressComponent.long_name}`
                    : addressComponent.long_name;
            }
        }

        if (japanAddress1) {
            // create a adress for Japan
            latestGeocodedAddress.street1 = `${japanAddress1.long_name}-${japanAddress2.long_name}-${japanAddress3.long_name} ${japanAddress4.long_name}`;
        }

        if (locality) {
            latestGeocodedAddress.street2 = locality.long_name;
        }

        return latestGeocodedAddress;
    },
}
